import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { WalkthroughPopover } from '../../common/components';
import { PageHeader, Button } from '@salesforce/design-system-react';
import { sendEvent } from '../../utilities/instrumentation';
import EinsteinLogo from '../../static/img/einstein-icon-36x36.svg';

import './DashboardHeader.scss';

export class DashboardHeader extends Component {
  renderDataExtensionButton() {
    const { formatMessage } = this.props.intl;
    const { ftux } = this.props;
    return (
      <div className="dataextension-button-container">
        {this.props.dataExtension.exists ? (
          <Button
            label={formatMessage({
              id: 'DashboardHeader.updateDataExtensions'
            })}
            onClick={() => {
              this.props.actions.openModal('updateDataExtension');
              sendEvent('clickButton', 'dataExtension', 'update');
            }}
          />
        ) : (
          <Button
            label={formatMessage({
              id: 'DashboardHeader.createDataExtensions'
            })}
            onClick={() => {
              this.props.actions.openModal('createDataExtension');
              sendEvent('clickButton', 'dataExtension', 'create');
            }}
          />
        )}
        <WalkthroughPopover
          step={ftux.steps.get('createDataExtensions')}
          numSteps={ftux.numSteps}
          position="left-bottom"
          actions={this.props.actions}
        />
      </div>
    );
  }

  render() {
    const { formatMessage, formatDate } = this.props.intl;
    const { updatedOn } = this.props.frequencies.data;
    const eventDate = new Date(Date.parse(updatedOn || 0));
    const dateOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return (
      <PageHeader
        className="dashboard-header page-header-bottom-connect"
        icon={<img className="einstein-logo" src={EinsteinLogo} alt="" />}
        title={formatMessage({ id: 'DashboardHeader.title' })}
        info={formatMessage(
          { id: 'DashboardHeader.info' },
          { date: formatDate(eventDate, dateOptions) }
        )}
        navRight={this.renderDataExtensionButton()}
        variant="base"
      />
    );
  }
}

DashboardHeader.propTypes = {
  frequencies: PropTypes.object.isRequired,
  frequency: PropTypes.object,
  ftux: PropTypes.object,
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(DashboardHeader);
